import { globalTracker } from 'App/babel/helpers/Tracker';
import { Icon, ClickableItem } from '@upsales/components';
import config from '../../../../../../config';
import getAngularModule from 'App/babel/angularHelpers/getAngularModule';
import i18next from 'i18next';
import { getInitials } from 'App/helpers/getInitials';
import ReactCreateClass from 'create-react-class';

const NavbarProfileDropdown = ReactCreateClass({
	getInitialState: function () {
		return {
			avatar: { initials: '', url: '', gravatar: false }
		};
	},
	componentDidMount: function () {
		this.setDropdown();

		this.onLogout = function () {
			const security = getAngularModule('security');
			security.logout();
		};

		i18next.on('languageChanged', () => {
			this.forceUpdate();
		});

		this.profilePickListener = Tools.$rootScope.$on('profileImage.updated', (e, data) => {
			const avatar = {
				gravatar: true,
				profileImg: true,
				initials: getInitials(Tools.AppService.getSelf())
			};
			if (data.imageId) {
				avatar.url =
					Tools.URL +
					Tools.API +
					Tools.AppService.getCustomerId() +
					'/resources/download/internal/' +
					data.imageId;
			}
			this.setState({ avatar });
		});
	},
	componentWillUnmount: function () {
		this.profilePickListener();
	},
	setRef: function (name, ref) {
		this[name] = ref;
	},
	setDropdown: function () {
		var settingsDrop = this._dropdownToggle;
		if (settingsDrop) {
			jQuery(settingsDrop).dropdown();
		}
	},
	getItem: function (state, text, icon, stateParams, key) {
		return (
			<li key={key || 'admin-drop-' + state}>
				<a href={this.props.getStateHref(state, stateParams)}>
					{icon ? (
						<span>
							<b className={'Icon ' + icon} />{' '}
						</span>
					) : null}{' '}
					{text}
				</a>
			</li>
		);
	},
	getSsoUrl: function (site) {
		return config.URL + config.API + 'function/externalSSO/' + site;
	},
	getItemSsoWindow: function (state, text, icon, stateParams, key) {
		var url = this.getSsoUrl(stateParams.site);
		return (
			<li key={key || 'admin-drop-' + state}>
				<a href={url} target="_blank">
					{icon ? (
						<span>
							<b className={'Icon ' + icon} />{' '}
						</span>
					) : null}{' '}
					{text}
				</a>
			</li>
		);
	},
	mixpanelEvent: function (event) {
		globalTracker.track(event);
	},
	render: function () {
		var self = this;
		var t = Tools.$translate;
		self.lang = {
			userSettings: t('admin.userSettings'),
			settings: t('admin.settings'),
			administration: t('navbar.administration'),
			accountSettings: t('admin.accountSettings'),
			classicAdmin: t('admin.classicAdmin'),
			logout: t('navbar.logout'),
			siteVisitors: t('default.siteVisitors'),
			automations: t('admin.automations'),
			mailsettings: t('default.mailsettings'),
			templates: t('mail.templates'),
			esign: t('default.eSign'),
			accountProfile: t('admin.accountProfile'),
			apiKeys: t('admin.apiKeys'),
			apps: t('admin.apps'),
			myProfile: t('default.myProfile'),
			educations: t('default.educations'),
			releaseNotes: t('default.releaseNotes'),
			looker: t('default.looker')
		};
		var isAdmin = this.props.self.administrator;
		var marketAdmin = this.props.self.userParams.mailAdmin;
		var features = this.props.accountSelf.features;
		var dropdownMenu;
		const showApps = features.integrations;

		var classNames = 'dropdown-menu upsales-tools';

		const settingsUrl = isAdmin || marketAdmin ? '#/admin/' : '#/admin/profile';

		dropdownMenu = (
			<ul className={classNames}>
				<div id="content">
					<a id="profile-dropdown-settings" href={settingsUrl}>
						<ClickableItem borderRadius icon="cogs" title={self.lang.settings} block />
					</a>
					{showApps ? (
						<a href="#/admin/integrations">
							<ClickableItem borderRadius icon="puzzle-piece" title={self.lang.apps} block />
						</a>
					) : null}
					<a href="https://support.upsales.com/hc/en-us" target="_blank">
						<ClickableItem borderRadius icon="question-circle" title={self.lang.educations} block />
					</a>
					<a href="https://upsales.releasenotes.io/" target="_blank">
						<ClickableItem borderRadius icon="gift" title={self.lang.releaseNotes} block />
					</a>
					<ClickableItem
						borderRadius
						onClick={this.onLogout}
						icon="power-off"
						title={self.lang.logout}
						block
					/>
				</div>
			</ul>
		);

		return (
			<li id="profile-dropdown" className="menu-item dropdown">
				<a className="dropdown-toggle" ref={self.setRef.bind(self, '_dropdownToggle')} data-toggle="dropdown">
					<span className="navbar-settings">
						{this.props.self && this.props.self.name ? (
							<ReactTemplates.TOOLS.avatar
								id="profile-img"
								user={this.props.self || ''}
								size={28}
								style={{ marginTop: '10px' }}
								avatar={self.state.avatar}
							/>
						) : (
							<Icon name="cogs" />
						)}
					</span>
				</a>
				{dropdownMenu}
			</li>
		);
	}
});

export default NavbarProfileDropdown;
